(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '£{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* Quantity steppers */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-change]');
    if (!button) return;
    var wrapper = button.closest('.qty');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + parseInt(button.getAttribute('data-qty-change'), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Auto-submit on change (sort, cart quantity) */
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (el.matches('[data-sort-by]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', el.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    if (el.matches('[data-cart-qty]')) {
      var form = el.closest('form');
      if (form) {
        clearTimeout(form._qtyTimer);
        form._qtyTimer = setTimeout(function () { form.submit(); }, 500);
      }
    }
  });

  /* Product gallery: swipeable slider + thumbnails */
  function initGallery(root) {
    var slider = root.querySelector('[data-slider]');
    if (!slider || slider._ready) return;
    slider._ready = true;
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var counter = root.querySelector('[data-slide-counter]');
    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var thumb = thumbs[i];
      if (thumb && thumb.parentNode && thumb.parentNode.parentNode) {
        var list = thumb.parentNode.parentNode;
        if (list.scrollWidth > list.clientWidth) list.scrollTo({ left: thumb.parentNode.offsetLeft - 8, behavior: 'smooth' });
      }
    }

    function goTo(i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      slider.scrollTo({ left: i * slider.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    var timer;
    slider.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(slider.scrollLeft / Math.max(1, slider.clientWidth));
        if (i !== current) setActive(i);
      }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () { goTo(current, false); });

    root._goToMedia = function (mediaId) {
      var index = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (index > -1) goTo(index);
    };

    var initial = parseInt(slider.getAttribute('data-initial'), 10) || 0;
    requestAnimationFrame(function () { goTo(initial, false); });
  }

  function setMainMedia(root, mediaId) {
    if (root._goToMedia) root._goToMedia(mediaId);
  }

  /* Variant selection */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var moneyFormat = section.getAttribute('data-money-format');
    var idInput = section.querySelector('[data-variant-id]');
    var pickers = section.querySelectorAll('[data-option-index]');

    function selectedOptions() {
      var options = [];
      pickers.forEach(function (picker) {
        var index = parseInt(picker.getAttribute('data-option-index'), 10);
        var value;
        if (picker.tagName === 'SELECT') value = picker.value;
        else {
          var checked = picker.querySelector('input:checked');
          value = checked ? checked.value : null;
        }
        options[index] = value;
      });
      return options;
    }

    function update() {
      var options = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
      var button = section.querySelector('[data-add-button]');
      var buttonText = section.querySelector('[data-add-button-text]');
      if (!variant) {
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? buttonText.getAttribute('data-default') : 'Sold out';

      var price = section.querySelector('[data-price]');
      if (price) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        price.classList.toggle('price--on-sale', !!onSale);
        price.querySelector('[data-price-current]').textContent = formatMoney(variant.price, moneyFormat);
        var compare = price.querySelector('[data-price-compare]');
        var save = price.querySelector('[data-price-save]');
        if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = 'Was ' + formatMoney(variant.compare_at_price, moneyFormat); }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price, moneyFormat); }
      }
      var klarna = section.querySelector('[data-klarna-amount]');
      if (klarna) klarna.textContent = formatMoney(Math.round(variant.price / 3), moneyFormat);

      section.querySelectorAll('[data-bundle-price]').forEach(function (el) {
        var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        var discount = parseFloat(el.getAttribute('data-discount')) || 0;
        var full = variant.price * qty;
        el.textContent = formatMoney(Math.round(full - full * discount / 100), moneyFormat);
      });
      section.querySelectorAll('[data-bundle-compare]').forEach(function (el) {
        var qty = parseInt(el.getAttribute('data-qty'), 10) || 1;
        el.textContent = formatMoney(variant.price * qty, moneyFormat);
      });

      if (section._setPhotoCount) section._setPhotoCount(variant);

      if (variant.featured_media) setMainMedia(section, String(variant.featured_media.id));

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    pickers.forEach(function (picker) { picker.addEventListener('change', update); });
  }

  /* Personalisation: upload preview + required validation */
  function initPersonalisation(section) {
    section.querySelectorAll('[data-upload]').forEach(function (box) {
      var input = box.querySelector('input[type="file"]');
      var preview = box.querySelector('.upload-box__preview');
      var cta = box.querySelector('.upload-box__cta');
      if (!input) return;
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        var max = parseInt(input.getAttribute('data-max-mb') || '20', 10) * 1024 * 1024;
        if (file && file.size > max) {
          alert('That file is too large. Please choose an image under ' + input.getAttribute('data-max-mb') + 'MB.');
          input.value = '';
          box.classList.remove('has-file');
          return;
        }
        if (file && preview && file.type.indexOf('image/') === 0) {
          preview.src = URL.createObjectURL(file);
          box.classList.add('has-file');
          if (cta) cta.textContent = file.name + ' (change)';
        } else {
          box.classList.remove('has-file');
          if (cta) cta.textContent = cta.getAttribute('data-default');
        }
      });
    });

    var form = section.querySelector('form[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      var error = section.querySelector('[data-form-error]');
      var missing = [];
      form.querySelectorAll('[data-required]').forEach(function (field) {
        if (field.disabled) return;
        var empty = field.type === 'file' ? !(field.files && field.files.length) : !field.value.trim();
        if (empty) missing.push(field.getAttribute('data-required'));
      });
      if (missing.length) {
        event.preventDefault();
        if (error) { error.hidden = false; error.textContent = 'Please complete: ' + missing.join(', ') + '.'; }
        var first = form.querySelector('[data-required]:not([disabled])');
        if (first) first.closest('.field, [data-upload]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var button = section.querySelector('[data-add-button]');
      if (button) { button.disabled = true; var t = section.querySelector('[data-add-button-text]'); if (t) t.textContent = 'Adding…'; }
    });
  }

  /* Multiple photo upload: number of fields follows the variant */
  function photoCountFor(root, variant) {
    var source = root.getAttribute('data-source');
    var max = parseInt(root.getAttribute('data-max'), 10) || 1;
    var count;
    if (source === 'fixed') {
      count = parseInt(root.getAttribute('data-fixed'), 10) || 1;
    } else {
      var match = variant && variant.title ? variant.title.match(/(\d+)/) : null;
      count = match ? parseInt(match[1], 10) : parseInt(root.getAttribute('data-fallback'), 10) || 0;
    }
    return Math.min(count, max);
  }

  function initMultiUpload(section) {
    var root = section.querySelector('[data-multi-upload]');
    if (!root) return;
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-upload-slot]'));
    var total = root.querySelector('[data-photo-total]');
    var progress = root.querySelector('[data-photo-progress]');

    function activeInputs() {
      return slots.filter(function (s) { return !s.hidden; }).map(function (s) { return s.querySelector('input[type="file"]'); });
    }

    function refreshProgress() {
      var inputs = activeInputs();
      var done = inputs.filter(function (i) { return i.files && i.files.length; }).length;
      if (progress) {
        progress.firstChild.nodeValue = done + ' / ';
        progress.classList.toggle('is-complete', inputs.length > 0 && done === inputs.length);
      }
    }

    section._setPhotoCount = function (variant) {
      var count = photoCountFor(root, variant);
      root.hidden = count === 0;
      slots.forEach(function (slot, index) {
        var on = index < count;
        slot.hidden = !on;
        slot.querySelector('input[type="file"]').disabled = !on;
      });
      if (total) total.textContent = count;
      refreshProgress();
    };

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-upload-all]')) {
        var files = Array.prototype.slice.call(event.target.files || []);
        var inputs = activeInputs();
        var empty = inputs.filter(function (i) { return !(i.files && i.files.length); });
        var targets = empty.length >= files.length ? empty : inputs;
        if (typeof DataTransfer === 'undefined') {
          alert('Please add your photos one by one using the squares below.');
          event.target.value = '';
          return;
        }
        files.slice(0, targets.length).forEach(function (file, i) {
          var dt = new DataTransfer();
          dt.items.add(file);
          targets[i].files = dt.files;
          targets[i].dispatchEvent(new Event('change', { bubbles: true }));
        });
        if (files.length > targets.length) {
          alert('You selected ' + files.length + ' photos, but this option uses ' + targets.length + '. We added the first ' + targets.length + '.');
        }
        event.target.value = '';
      }
      refreshProgress();
    });

    var product = section.querySelector('[data-product-json]');
    var variantId = section.querySelector('[data-variant-id]');
    if (product && variantId) {
      var data = JSON.parse(product.textContent);
      var current = data.variants.find(function (v) { return String(v.id) === String(variantId.value); });
      section._setPhotoCount(current || data.variants[0]);
    }
  }

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    initGallery(section);
    initProduct(section);
    initPersonalisation(section);
    initMultiUpload(section);
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-product-section]');
    if (section) { initGallery(section); initProduct(section); initPersonalisation(section); initMultiUpload(section); }
  });
})();
